class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetButton = this.querySelector('.facets__button-show');
    if (facetButton) {
      facetButton.onclick = (event) => {
        event.currentTarget.querySelector('.label-hide').classList.toggle('hidden');
        event.currentTarget.querySelector('.label-show').classList.toggle('hidden');
        if (!event.currentTarget.classList.contains('facets__button-show_up')) {
          if (event.currentTarget.querySelector('.label-hide').classList.contains('hidden')) {
            let width = this.querySelector('.facets__container').offsetWidth + 32;
            this.querySelector('.facets__container').classList.add('hide');
            this.querySelector('.facets__container').style.marginLeft = `-${width + 64}px`;
            document.querySelector('.products-grid').style.marginLeft = `-${width}px`;
            document.querySelector('.facets__top').style.marginLeft = `-${width}px`;
          }
          else {
            this.querySelector('.facets__container').classList.remove('hide');
            this.querySelector('.facets__container').style.marginLeft = '0';
            document.querySelector('.products-grid').style.marginLeft = '0';
            document.querySelector('.facets__top').style.marginLeft = '0';
          }
          if (document.querySelector('.products-grid'))
            document.querySelector('.products-grid').classList.toggle('full-width');
          if (document.querySelector('.collection-results'))
            document.querySelector('.collection-results').classList.toggle('full-width');
        }
        else {
          if (event.currentTarget.querySelector('.label-hide').classList.contains('hidden')) {
            let height = this.querySelector('.facets__container').offsetHeight;
            this.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
          }
          else {
            this.querySelector('.facets__wrapper').style.marginTop = '0';
          }
        }
      }

      const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');
      let prevWidth = 0;
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;

        if (!facetButton.classList.contains('facets__button-show_up') && entry.contentRect.width !== prevWidth) {
          if (facetButton.querySelector('.label-hide').classList.contains('hidden')) {
            if (entry.contentRect.width > 749) {
              let width = this.querySelector('.facets__container').offsetWidth + 32;
              this.querySelector('.facets__container').classList.add('hide');
              this.querySelector('.facets__container').style.marginLeft = `-${width + 64}px`;
              document.querySelector('.products-grid').style.marginLeft = `-${width}px`;
              document.querySelector('.facets__top').style.marginLeft = `-${width}px`;
            }
            else {
              this.querySelector('.facets__container').classList.remove('hide');
              this.querySelector('.facets__container').style.marginLeft = '0';
              document.querySelector('.products-grid').style.marginLeft = '0';
              document.querySelector('.facets__top').style.marginLeft = '0';
            }
          }
        }
        else {
          if (facetButton.querySelector('.label-hide').classList.contains('hidden') && entry.contentRect.width !== prevWidth) {
            if (entry.contentRect.width > 749 ) {
              let height = this.querySelector('.facets__wrapper').offsetHeight;
              this.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
              prevWidth = entry.contentRect.width;
            }
            else {
              this.querySelector('.facets__wrapper').style.marginTop = '0';
            }
          }
        }
        
      });
      sectionResizeObserver.observe(collectionGridSection);
    }

    document.addEventListener('click', (e) => {
      const detailsList = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure');
      const details = e.target.closest(".facets__disclosure[open]");

      if (!details && detailsList) {
        detailsList.forEach((item) => {
          item.removeAttribute("open");
        })
      }
    })

    // ── Toolbar toggle logic ──
    const toolbarToggles = this.querySelectorAll('[data-toolbar-toggle]');
    if (toolbarToggles.length) {
      const backdrop = this.querySelector('[data-facets-backdrop]');
      const panel = this.querySelector('[data-toolbar-panel="filter"]');
      const closeBtns = this.querySelectorAll('[data-facets-close]');
      const applyBtn = this.querySelector('[data-facets-apply]');
      const resetLink = this.querySelector('[data-facets-reset]');
      let lastFocused = null;

      const showDrawer = () => {
        panel.hidden = false;
        if (backdrop) backdrop.hidden = false;
        // Drawer width + left are driven entirely by CSS (--facets-drawer-width
        // on desktop, 100% on mobile when body.facets-overlay-open). No JS
        // measurement is needed — measuring required a transient body class
        // toggle which could cause the filter button to briefly disappear if
        // the browser interleaved a paint between the add and remove.
        // Scroll lock: class on html AND body (covers themes where either
        // is the scroll container), plus position: fixed with scrollY
        // preserved on body to lock iOS Safari which otherwise ignores
        // overflow: hidden on body.
        const y = window.scrollY;
        // scrollbar-gutter: stable on html (in base.css) keeps the
        // scrollbar gutter reserved when body becomes position: fixed,
        // so no horizontal padding hack is needed here.
        document.documentElement.classList.add('facets-overlay-open');
        document.body.classList.add('facets-overlay-open');
        document.body.style.top = `-${y}px`;
        document.body.style.position = 'fixed';
        /* `left: 0; right: 0` instead of `width: 100%` so the fixed-
           position body respects html's `scrollbar-gutter: stable`
           reservation. With `width: 100%` the body extended over the
           scrollbar gutter area, shifting page content right by the
           gutter width (~15px on Windows, ~0px on macOS overlay scroll
           but still visible on some setups). Bounding by left/right
           keeps body's content within the same horizontal range as
           before the lock. */
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.dataset.facetsLockY = String(y);
        // Force the site header into opaque mode — the user is at the
        // top of the products grid (past the hero), so the transparent
        // hero-mode shouldn't apply.
        const headerSection = document.querySelector('.shopify-section-header');
        if (headerSection) headerSection.classList.add('header--opaque');
        FacetFiltersForm.deferGridRender = true;
        toolbarToggles.forEach(b => {
          b.setAttribute('aria-expanded', 'true');
          b.classList.add('is-active');
        });
        const firstFocusable = panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus({ preventScroll: true });
      };

      const openOverlay = () => {
        if (!panel) return;
        lastFocused = document.activeElement;
        /* Smooth-scroll to the top of the products-grid section before
           locking, so when the user closes the drawer they land at the
           top of the grid. showDrawer must only run AFTER the scroll
           has settled — otherwise it captures the in-flight scrollY for
           the lock, and the lock freezes the page mid-animation.
           Pattern: smooth scrollTo + scrollend listener + timeout
           fallback (for Safari versions older than 18.2 which don't
           dispatch scrollend). The fallback fires unconditionally at
           600ms, with a `done` guard preventing double-fire. */
        const toolbar = document.querySelector('.facets__toolbar');
        if (!toolbar) { showDrawer(); return; }

        const headerEl = document.querySelector('.shopify-section-header');
        const headerHeight = headerEl ? headerEl.offsetHeight : 0;
        const toolbarTop = toolbar.getBoundingClientRect().top + window.scrollY;
        const targetY = Math.max(0, toolbarTop - headerHeight);

        // Already at target → no scroll needed
        if (Math.abs(window.scrollY - targetY) < 2) {
          showDrawer();
          return;
        }

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          window.removeEventListener('scrollend', finish);
          showDrawer();
        };
        window.addEventListener('scrollend', finish, { once: true });
        setTimeout(finish, 600);
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      };

      const closeOverlay = () => {
        if (!panel) return;
        panel.hidden = true;
        if (backdrop) backdrop.hidden = true;
        // (No inline left/width/backdrop-left to clear — those are CSS-driven.)
        // Unlock body scroll + restore the scrollY captured at open
        // time so the user stays exactly where they were before opening
        // the drawer (no scroll relocation on Apply / Reset / close).
        const y = parseInt(document.body.dataset.facetsLockY || '0', 10);
        document.documentElement.classList.remove('facets-overlay-open');
        document.body.classList.remove('facets-overlay-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        /* Legacy: previous versions set inline width:100% — clear it
           on close so a one-off pre-update lock doesn't leak the
           inline width across navigations. */
        document.body.style.width = '';
        delete document.body.dataset.facetsLockY;
        window.scrollTo(0, y);
        FacetFiltersForm.deferGridRender = false;
        toolbarToggles.forEach(b => {
          b.setAttribute('aria-expanded', 'false');
          b.classList.remove('is-active');
        });
        this.querySelectorAll('.facets__wrapper--toolbar details.facets__disclosure[open]').forEach(d => {
          d.removeAttribute('open');
        });
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      };

      this._closeAllToolbar = closeOverlay;

      toolbarToggles.forEach(btn => {
        btn.addEventListener('click', () => {
          if (panel && panel.hidden) openOverlay();
          else closeOverlay();
        });
      });

      closeBtns.forEach(b => b.addEventListener('click', closeOverlay));
      if (backdrop) backdrop.addEventListener('click', closeOverlay);

      // ESC + simple focus trap while open.
      document.addEventListener('keydown', (e) => {
        if (!panel || panel.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeOverlay();
          return;
        }
        if (e.key !== 'Tab') return;
        const focusable = Array.from(
          panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter(el => el.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      if (applyBtn) {
        applyBtn.addEventListener('click', () => {
          FacetFiltersForm.deferGridRender = false;
          const form = this.querySelector('form');
          const searchParams = this.createSearchParams(form);
          this.onSubmitForm(searchParams, { target: form });
          closeOverlay();
        });
      }

      if (resetLink) {
        resetLink.addEventListener('click', (e) => {
          e.preventDefault();
          FacetFiltersForm.deferGridRender = false;
          const url = resetLink.getAttribute('href') || '';
          const searchParams = url.indexOf('?') !== -1 ? url.slice(url.indexOf('?') + 1) : '';
          FacetFiltersForm.renderPage(searchParams, null);
          closeOverlay();
        });
      }

      // ── One-filter-at-a-time inside the Filter panel ──
      // Each filter is a <details>; without this, opening multiple at once
      // made their absolutely-positioned display panels stack on top of each
      // other which was especially bad on mobile (all overlapping).
      const bindOneAtATime = () => {
        const innerDisclosures = this.querySelectorAll('.facets__wrapper--toolbar details.facets__disclosure');
        innerDisclosures.forEach(d => {
          if (d.dataset.singleOpenBound) return;
          d.dataset.singleOpenBound = '1';
          d.addEventListener('toggle', () => {
            if (!d.open) return;
            innerDisclosures.forEach(other => {
              if (other !== d && other.open) other.removeAttribute('open');
            });
          });
        });
      };
      bindOneAtATime();
      // Re-bind after AJAX re-render replaces filter DOM
      this._bindOneAtATime = bindOneAtATime;

      // Sort radio → hidden select sync
      const sortRadios = this.querySelectorAll('input[name="sort_by_visual"]');
      const sortSelect = this.querySelector('select[name="sort_by"]');
      sortRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (sortSelect) {
            sortSelect.value = radio.value;
            sortSelect.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (!FacetFiltersForm.deferGridRender) {
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        if (!FacetFiltersForm.deferGridRender) FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    if (!FacetFiltersForm.deferGridRender) FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
      loadMore();
    
    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    // Pending count inside the Apply button (numeric only).
    const pending = document.querySelector('[data-facets-pending-count]');
    if (pending) {
      const numeric = (count.match(/\d[\d,]*/) || [''])[0];
      if (numeric) pending.textContent = numeric;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();

    // Re-bind toolbar sort radios after re-render
    document.querySelectorAll('facet-filters-form').forEach(el => {
      const sortRadios = el.querySelectorAll('input[name="sort_by_visual"]');
      const sortSelect = el.querySelector('select[name="sort_by"]');
      if (sortRadios.length && sortSelect) {
        sortRadios.forEach(radio => {
          radio.addEventListener('change', () => {
            sortSelect.value = radio.value;
            sortSelect.dispatchEvent(new Event('input', { bubbles: true }));
          });
        });
      }
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    // Collapse the toolbar after any reset / facet-remove click — the user
    // expects the whole Filter/Sort panel to drop away once they've cleared,
    // not to linger open.
    if (typeof this._closeAllToolbar === 'function') this._closeAllToolbar();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.deferGridRender = false;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ── Sticky toolbar on scroll ──
   Scroll-driven state machine: on every scroll, compare the toolbar's
   top edge and the products grid's bottom edge against the sticky
   header's bottom edge.
     • Sticky when: toolbar has scrolled above the header AND the
       grid still has area below the header → user is "inside" the
       product grid.
     • Released otherwise: either still above the toolbar, or past
       the end of the products grid.
   Switched from `IntersectionObserver` to scroll-based checks because
   IO fires only at state transitions, and the boundingClientRect
   read at that moment was ambiguous (could be just above the trigger
   line OR way below the viewport on initial load). A scroll listener
   reads live positions and avoids the disambiguation problem entirely. */
(function initStickyToolbar() {
  const container = document.querySelector('.collection-wrapper--toolbar .facets-container');
  if (!container) return;

  const toolbar = container.querySelector('.facets__toolbar');
  if (!toolbar) return;

  /* `.products-grid` lives inside the same `.collection-wrapper--toolbar`.
     The toolbar should release as soon as the bottom of this grid
     crosses above the header bar. If absent (empty collection), the
     toolbar still sticks but never releases on its own — same as the
     original behaviour. */
  const productsGrid = document.querySelector('.collection-wrapper--toolbar .products-grid');

  let spacer = null;

  function stick() {
    if (container.classList.contains('is-stuck')) return;
    /* Create spacer to prevent layout shift when toolbar leaves flow */
    spacer = document.createElement('div');
    spacer.style.height = toolbar.offsetHeight + 'px';
    spacer.setAttribute('aria-hidden', 'true');
    container.insertBefore(spacer, container.firstChild);
    container.classList.add('is-stuck');
  }

  function unstick() {
    if (!container.classList.contains('is-stuck')) return;
    container.classList.remove('is-stuck');
    if (spacer && spacer.parentNode) {
      spacer.parentNode.removeChild(spacer);
      spacer = null;
    }
  }

  function getHeaderHeight() {
    return parseInt(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height') || '60', 10
    );
  }

  function updateStickyState() {
    const headerPx = getHeaderHeight();

    /* Top edge of the toolbar's natural-flow position. When stuck,
       the spacer above sits where the toolbar would naturally be, so
       we use the spacer's top instead so the toggle has hysteresis
       (otherwise the toolbar flickers in/out at the trigger line). */
    const naturalTopEl = spacer || container;
    const naturalTop = naturalTopEl.getBoundingClientRect().top;

    /* `productsGrid.getBoundingClientRect().bottom` is the y-coord of
       the grid's bottom edge relative to the viewport. If it's still
       below the header line, there's grid content left to scroll. */
    const gridBottom = productsGrid
      ? productsGrid.getBoundingClientRect().bottom
      : Infinity;

    const pastTop = naturalTop <= headerPx;
    const pastGrid = gridBottom <= headerPx;

    if (pastTop && !pastGrid) {
      stick();
    } else {
      unstick();
    }
  }

  /* rAF throttle — scroll events fire dozens of times per second; one
     check per animation frame is plenty and stays smooth. */
  let scrollTicking = false;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      updateStickyState();
      scrollTicking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateStickyState);

  /* Initial check after layout settles — covers reloads at any scroll
     position. */
  updateStickyState();
})();
